/**
 * HidroVerse — Brand & Design Tokens
 *
 * This is the SINGLE SOURCE OF TRUTH for colour, type, spacing rhythm and
 * motion. The Home page is the canon — every other surface mirrors these
 * tokens. To re-skin the brand, edit this file. Do NOT introduce new hex
 * literals in component code.
 *
 *   import { COLOR, TYPE, SPACE, MOTION } from "@/lib/theme";
 */

export const COLOR = {
  // Light hybrid surfaces
  paper: "#FAFAF7",       // warm white — primary light background
  paperCool: "#F5F7FA",   // cool white — alt light background
  ink: "#0C2A40",         // navy — headings on light
  body: "#1A1F25",        // dark slate — body text on light
  muted: "#5B6877",       // captions, hairlines, eyebrows on light

  // Dark cinematic surfaces (hero, footer, CTA bands)
  night: "#070A0D",       // near-black — primary dark background
  nightSoft: "#0E1318",   // softer dark — section breaks
  mist: "#9AA7B4",        // body text on dark
  whisper: "rgba(245,247,250,0.55)", // eyebrows / industries strip on dark

  // Accents (used identically on light and dark)
  teal: "#1FB6C1",        // primary accent
  deepTeal: "#1D6A8C",    // hover / pressed
  forest: "#42954B",      // secondary accent (use sparingly)
};

export const TYPE = {
  display: "var(--font-display, 'Söhne', 'Inter', system-ui, sans-serif)",
  body: "var(--font-body, 'Söhne', 'Inter', system-ui, sans-serif)",
  mono: "var(--font-mono, 'JetBrains Mono', 'IBM Plex Mono', monospace)",
};

export const SPACE = {
  pageMaxW: "max-w-[1500px]",
  pageMaxWnarrow: "max-w-[1200px]",
  padX: "px-6 md:px-12 lg:px-20",
  // Vertical rhythm — vetted on Home; use one of these, do NOT invent new pad values
  sectionLg: "py-20 md:py-28",
  sectionMd: "py-14 md:py-20",
  sectionSm: "py-10 md:py-14",
};

export const MOTION = {
  // Use Framer Motion ease tokens consistent with the Home hero animations
  ease: [0.2, 0.7, 0.2, 1],
  durFast: 0.6,
  durMed: 0.9,
  durSlow: 1.3,
};

// Eyebrow style — applied identically across the site. Spread into `style={}`.
export const EYEBROW = {
  fontFamily: TYPE.mono,
  fontSize: "0.62rem",
  letterSpacing: "0.28em",
  textTransform: "uppercase",
  color: COLOR.teal,
  fontWeight: 700,
};
